import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import {
  alphabets,
  connectedStrikers,
  pendingStrikers,
  tabsArr,
} from "./constants";
import styles from "./styles.module.scss";
import { OnCollapseIcon } from "pages/m2c-simulation/icons";
import { ConditionalRenderer } from "components";
import { Divider, Input, Popover, Spin } from "antd";
import { useEffect, useState } from "react";
import {
  Accordians,
  AddStriker,
  StrikerCard,
  StrikerCountCards,
  Tabs,
} from "./components";
import {
  ConnectedStrikerIcon,
  NameIcon,
  PendingStrikerIcon,
  SearchIcon,
  StrikerFilterIcon,
} from "icons";
import { UseApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-api-call";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";
import { getUniquesObjectsFromArray, isValidEmail } from "utils/helpers";

export const StrikersList = ({
  userID,
  handleNext,
  goTo,
  setIsStrikerSelected,
}) => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [userNotInDB, setUserNotInDB] = useState(false);

  const { data: allStrikersData, isLoading: allStrikersDataLoading } =
    UseApiCallForOldDashboardData({
      url: "get_all_strikers_by_coach",
      skip: !userID,
      method: "POST",
      body: {
        userID,
      },
    });

  const [
    searchStriker,
    {
      data: searchedStrikerData,
      isLoading: searchedStrikerDataLoading,
      error: searchedStrikerDataErro,
    },
  ] = UseLazyApiCallOldDashboard({
    url: "search_striker",
    method: "POST",
    paramsData: {
      search,
      userID,
    },
  });

  const [activeTab, setActiveTab] = useState(tabsArr?.[0].key);
  const initalTotalData = allStrikersData?.strikers;

  useEffect(() => {
    setUsers(allStrikersData?.strikers);
  }, [activeTab, allStrikersData]);

  function handleSearchStriker(e) {
    const { value } = e.target;
    setSearch(value);
  }

  useEffect(() => {
    if (!search) {
      setUsers(initalTotalData);
    }
  }, [search]);

  async function handleSubmitSearch(e) {
    e.preventDefault();
    if (!search) return;
    const localSearchData = initalTotalData?.filter((item) =>
      item.username.toLowerCase().includes(search?.toLowerCase())
    );
    try {
      const data = await searchStriker();
      if (data) {
        const formatedResponse = data?.users?.map((item) => {
          return {
            ...item,
            userId: item?.id,
            username: `${item.firstName} ${item.lastName}`,
          };
        });

        const totalData = [...localSearchData, ...data?.strikers];
        const uniqueOnes = getUniquesObjectsFromArray(totalData);

        setUserNotInDB(uniqueOnes?.length < 1 && isValidEmail(search));
        setUsers([...uniqueOnes]);
      }
    } catch (error) {}
  }

  const filterOptions = [
    {
      label: "Connected Strikers",
      icon: ConnectedStrikerIcon,
      key: "connected",
    },
    {
      label: "Pending Strikers",
      icon: PendingStrikerIcon,
      key: "pending",
    },
  ];

  function resetFilter() {
    setUsers(initalTotalData);
  }

  return (
    <div className={styles.strikersListContainer}>
      <div className={styles.header}>
        <h2 className={styles.heading}>Connections</h2>
        <Popover
          placement="bottomLeft"
          style={{ padding: "0" }}
          overlayInnerStyle={{ padding: "5px 0px 0px 0px" }}
          content={
            <FilterStrikers
              filterOptions={filterOptions}
              setUsers={setUsers}
              initalTotalData={initalTotalData}
              resetFilter={resetFilter}
              setSearch={setSearch}
            />
          }
          trigger={"click"}
        >
          <div className={styles.iconCircle}>
            <StrikerFilterIcon />
          </div>
        </Popover>
      </div>
      <Divider style={{ margin: "16px 0px" }}></Divider>
      {/* <StrikerCountCards /> */}
      <div className={styles.searchStriker}>
        <NameIcon />
        <div>Search Striker</div>
      </div>
      <form onSubmit={handleSubmitSearch}>
        <div className={styles.searchAndAdd}>
          <Input
            placeholder="Enter a Name or Email"
            type="text"
            value={search}
            onChange={handleSearchStriker}
            height={34}
            style={{ margin: "15px 0px", width: "100%" }}
            prefix={<SearchIcon width={13} />}
          />
          <AddStriker />
        </div>
      </form>

      <Accordians
        users={users}
        activeTab={activeTab}
        handleNext={handleNext}
        goTo={goTo}
        setIsStrikerSelected={setIsStrikerSelected}
        allStrikersDataLoading={allStrikersDataLoading}
        userNotInDB={userNotInDB}
        search={search}
      />
    </div>
  );
};

function FilterStrikers({
  filterOptions,
  setUsers,
  resetFilter,
  initalTotalData,
  setSearch,
}) {
  const [activeOption, setActiveOption] = useState("");
  function filterStrikers(key) {
    const filtered = initalTotalData?.filter((item) => item.status === key);
    setUsers(filtered);
  }

  function handleClickFilterOption(item) {
    setSearch("");
    if (item.key === activeOption) {
      resetFilter();
      setActiveOption("");
    } else {
      filterStrikers(item.key);
      setActiveOption(item.key);
    }
  }
  return (
    <div className={styles.strikerfilterContainer}>
      {filterOptions.map((item) => (
        <div
          className={`${styles.filterOption} ${
            activeOption === item.key ? styles.active : ""
          }`}
          onClick={() => handleClickFilterOption(item)}
        >
          <div className={styles.iconCircle}>
            <item.icon />
          </div>
          <div>{item.label}</div>
        </div>
      ))}
    </div>
  );
}
